<template>
  <Event ref="eventRef" :event="mappedEvent" @open-edit-component="openAudit">
    <div class="font-bold eventContentGrid">
      <div class="text-truncate">
        <div class="text-truncate">
          {{ t("components.event-action.auditResult.AuditResult.title") }}:
        </div>
        <div v-if="event.location?.trim()?.length > 0" class="text-truncate">
          {{ t("views.AuditResult.Location") }}:
        </div>
        <div v-if="event.leader" class="text-truncate">
          {{ t("views.AuditResult.Auditleader") }}:
        </div>
        <div v-if="event.participants.length > 0" class="text-truncate">
          {{ t("views.AuditResult.Auditparticipant") }}:
        </div>
        <div v-if="event.resultValue != null" class="text-truncate">
          {{ t("views.AuditResult.Auditresult") }}:
        </div>
      </div>
      <div class="text-truncate">
        <div class="text-truncate">{{ auditName }}</div>
        <div v-if="event.location?.trim()?.length > 0" class="text-truncate">
          {{ event.location }}
        </div>
        <div v-if="event.leader">
          <div class="text-truncate">{{ event.leader?.preferredName }}</div>
        </div>
        <div v-if="event.participants.length > 0">
          <div class="text-truncate">
            {{ event.participants.map((user) => user.preferredName).join(" ,") }}
          </div>
        </div>
        <div v-if="event.resultValue != null">
          <div class="text-truncate">
            {{
              n(event.resultValue, {
                style: "percent",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })
            }}
          </div>
        </div>
      </div>
    </div>
  </Event>
</template>

<script setup lang="ts">
import { computed, type PropType, ref } from "vue";
import { useAuditNameQuery, type EventListEventFields_AuditResult_Fragment } from "@/graphql";
import Event from "../event/EventComponent.vue";

import router from "@/router";
import { useTranslation } from "@/language/translation";

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFields_AuditResult_Fragment>,
    required: true,
  },
});

const { loading, result } = useAuditNameQuery(
  () => ({
    id: props.event.auditId!,
    revision: props.event.auditRevision,
  }),
  computed(() => ({
    fetchPolicy: "cache-first",
    enabled: props.event.auditId != null && props.event.auditRevision != null,
  })),
);

const { t, getDisplayName } = useTranslation();

const auditName = computed(() => {
  if (loading.value) {
    return t("global.loading");
  }
  const audit = result.value?.audits?.[0];
  return audit ? getDisplayName(audit) : t("global.deleted");
});

const eventRef = ref<InstanceType<typeof Event>>();
const mappedEvent = computed(() => ({
  ...props.event,
}));
function openAudit() {
  router.push({
    name: "AuditResult",
    params: {
      id: props.event.id.toString(),
      revision: props.event.auditRevision.toString(),
    },
  });
}
defineExpose({
  eventRef,
});

const { n } = useTranslation();
</script>

<style lang="scss" scoped>
.eventContentGrid {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1em 2em;
}
</style>
